export default __webpack_public_path__ + "a11d55cf5a96e48f902a78cef2242d4f.gltf";